import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const Card = ({ children, className, padding, ...rest }) => {
    return (_jsx("div", { className: classNames("eds-card", { [`eds-spacing--p-${padding}`]: !!padding }, className), ...rest, children: children }));
};
